import styled from 'styled-components/macro'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`

export { Container }
